import { EpimsBaseEntityDto } from './epim-base.dto';
export class ContractorDto extends EpimsBaseEntityDto {

    id: string;
    ContractorName: string;
    Address: string;
    PhoneNo: string;
    Email: string;
    VendorNo: string;
    Website: string;
    SubscriberId: string;
    SiteId: string;

}